import React, { useMemo } from "react";
import { UserData } from "@/entities/users/types";
import ChampionsMapping from "./ChampionsMapping";
import { useReport } from "@/entities/reporting/hooks";
import {
  OverallScoringData,
  ReportType,
  SettingsPeriod
} from "@/entities/reporting/types";

interface Props {
  leadUser?: UserData;
}

const ChampionsMappingWrapper: React.FC<Props> = ({ leadUser }) => {
  const reportPeriod = SettingsPeriod.ALL_TIMES;

  const { report: overallReport, isLoading } = useReport(
    ReportType.CHAMPION_MAPPING_SCORE,
    reportPeriod
  );

  const overallData: OverallScoringData = useMemo(
    () => overallReport?.championsMappingScore?.overall ?? undefined,
    [overallReport]
  );

  return (
    <ChampionsMapping
      leadUser={leadUser}
      overallData={overallData}
      period={reportPeriod}
      isLoading={isLoading}
    />
  );
};

export default ChampionsMappingWrapper;
